(function () {
  // 1. Liste des URL à obfusquer (mets les chemins, sans le domaine)
  //const TARGETS = [
    '/collections/greenhouse-cbd-flower',
    '/collections/indoor-cbd-flower',
    '/collections/indica-cbd-flower',
    '/collections/sativa-cbd-flower',
    '/collections/small-buds-cbd-flower',
    '/collections/hybrid-cbd'

  //];

  // Normalise un href en chemin comparable (gère http/https, www, slash final)
  function pathOf(href) {
    try {
      const u = new URL(href, window.location.origin);
      // on ne traite que ton propre domaine ou domaine.fr
      return u.pathname.replace(/\/+$/, '');
    } catch (e) {
      return null;
    }
  }

  function isTarget(href) {
    const p = pathOf(href);
    if (!p) return false;
    return TARGETS.some(t => p === t.replace(/\/+$/, ''));
  }

  // 2. Transforme un <a> en lien obfusqué, en gardant le design
  function obfuscate(a) {
    if (!a.href || a.dataset.obf) return;      // déjà traité ?
    if (!isTarget(a.href)) return;

    a.dataset.obf = btoa(a.href);              // URL encodée en base64
    a.removeAttribute('href');                 // plus de lien crawlable
    a.style.cursor = 'pointer';
    a.setAttribute('role', 'link');
    a.setAttribute('tabindex', '0');
  }

  function scan(root) {
    (root || document).querySelectorAll('a[href]').forEach(obfuscate);
  }

  // 3. Gestion du clic (délégation, marche même pour le contenu ajouté après)
  document.addEventListener('click', function (e) {
    const el = e.target.closest('[data-obf]');
    if (!el) return;
    e.preventDefault();
    window.location = atob(el.dataset.obf);
  });

  // accessibilité clavier
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    const el = e.target.closest('[data-obf]');
    if (el) window.location = atob(el.dataset.obf);
  });

  // 4. Premier passage
  document.addEventListener('DOMContentLoaded', () => scan());

  // 5. Contenu chargé dynamiquement (menu ajax, filtres de collection, etc.)
  const mo = new MutationObserver(muts => {
    muts.forEach(m => m.addedNodes.forEach(n => {
      if (n.nodeType === 1) {
        if (n.matches && n.matches('a[href]')) obfuscate(n);
        scan(n);
      }
    }));
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();